<template>
  <v-select
    v-model="internalValue"
    :items="statusOptions"
    :menu-props="{ maxHeight: '400' }"
    label="Status"
    multiple    
    outlined
    dense
    hide-details
    clearable    
    @change="onChange"
  >
    <template v-slot:prepend-item>
      <v-list-item-group>
        <v-list-item @click="selectAll">
          <v-list-item-content>
            <v-list-item-title>Select All</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item @click="selectNone">
          <v-list-item-content>
            <v-list-item-title>Select None</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list-item-group>
      <v-divider></v-divider>
    </template>
  </v-select>
</template>

<script>
import { getCatValues } from "@/mixins/getCatValues.js"; // adjust path as needed

export default {
  name: "StatusMultiSelect",
  mixins: [getCatValues],
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    catName: {
      type: String,
      default: "athlete_status",
    },
    updateRouter: {
      type: Function,
      default: null,
    },
    getAllOptions: {
      type: Function,
      default: null,
    },
  },
  computed: {
    statusOptions() {
      return this.catValueListArray
        ? this.catValueListArray(this.catName)
        : [];
    },
    internalValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
        if (this.updateRouter) this.updateRouter();
      },
    },
  },
  methods: {
    selectAll() {
      const allOptions = this.getAllOptions
        ? this.getAllOptions()
        : [...this.statusOptions];
      this.$emit("input", allOptions);
      if (this.updateRouter) this.updateRouter();
    },
    selectNone() {
      this.$emit("input", []);
      if (this.updateRouter) this.updateRouter();
    },
    onChange(val) {
      const filtered = val.filter(
        (item) => !["Select All", "Select None"].includes(item)
      );
      this.$emit("input", filtered);
      if (this.updateRouter) this.updateRouter();
    },
  },
};
</script>